module.exports = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  SELECT: 'select',
  CHECKBOXES: 'checkboxes',
  RADIO: 'radio',
  IMAGE: 'image'
}
